export default {
  unknown: 'Beklenmeyen bir hata oluştu',
  errorOccured: 'Bir hata oluştu',
  recordNotChanged: 'Kayıt Değiştirilemedi',
  error: 'Hata',
  errorUploadingFiles: 'Dosya yüklemede hata',
  notUploadedFile: 'Dosya Yüklenemedi.',
  transferError: 'Hata. Aktarılamadı',
  recordCountError: '{0} kayıttan daha fazlası Excel olarak indirilemez. Lütfen Vektör ile iletişime geçin.',
  unknownError: 'Bilinmeyen hata',
  errorOccuredDuringUpdate: 'Güncelleme sırasında bir hata oluştu.',
  negativeOrEmptyError: 'Değer negatif veya boş olamaz.',
  excelUploadErrors: 'Excel Yükleme Hataları',
  totalRowsWithErrors: 'Toplam {count} satırda hata bulundu.',
  pleaseFixErrorsAndReupload: 'Lütfen aşağıdaki hataları düzelterek tekrar yükleyin.',
  errorRow: 'Hatalı Satır (Hata Sayısı)',
  errorColumnNumber: 'Hatalı Sütun No',
  errorMessage: 'Hata Mesajı',
  generalRow: 'Genel Satır',
  rowNumber: '{number}. Satır',
  close: 'Kapat',
  errorDescriptionNotFound: 'Hata açıklaması bulunamadı',
  endDateMustBeAfterStartDate: 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır',
};
